var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload_icon",
    "data-name": "upload icon",
    transform: "translate(0.171)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2775",
    "data-name": "Rectangle 2775",
    width: 51,
    height: 51,
    transform: "translate(-0.171)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2591",
    "data-name": "Path 2591",
    d: "M32.035,118.449h-4.81a11.224,11.224,0,0,1,0-22.449,11.525,11.525,0,0,1,2.786.341",
    transform: "translate(-12.793 -76.791)",
    fill: "none",
    stroke: "#dcdcdc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2592",
    "data-name": "Path 2592",
    d: "M80,64.03a16.035,16.035,0,1,1,28.862,9.621",
    transform: "translate(-63.965 -38.407)",
    fill: "none",
    stroke: "#dcdcdc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2593",
    "data-name": "Path 2593",
    d: "M118.1,134.795,124.895,128l6.795,6.795",
    transform: "translate(-94.429 -102.377)",
    fill: "none",
    stroke: "#dcdcdc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_125",
    "data-name": "Line 125",
    y1: 16,
    transform: "translate(30.829 26)",
    fill: "none",
    stroke: "#dcdcdc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload_icon.487b47e24e61c7c799904cc9ab445cad.svg";
export { ForwardRef as ReactComponent };